/* eslint-disable react/react-in-jsx-scope */
import { gql } from '@apollo/client';
import { rateUnitFragment, sellerFragment } from 'helper/fragment';

export const OFFERS_QUERY = gql`
  ${rateUnitFragment}
  query offers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    offers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offers {
        updatedByUserId
        createdByUserId
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        actualQuantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        trader {
          id
          firstName
          lastName
          traderType
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
        portOfLoading {
          id
          name
          city
        }
        portsOfDischarge {
          id
          name
          city
        }
        offerCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const OFFERS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription offers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    offers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offer {
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        createdByUserId
        updatedByUserId
        trader {
          id
          firstName
          lastName
          traderType
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
        portOfLoading {
          id
          name
          city
        }
        portsOfDischarge {
          id
          name
          city
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const FORWARD_OFFERS_QUERY = gql`
  ${rateUnitFragment}
  query allForwardOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForwardOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      forwardOffers {
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        trader {
          id
          firstName
          lastName
          traderType
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
        offerCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const FORWARD_OFFERS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription allForwardOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForwardOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      forwardOffer {
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        trader {
          id
          firstName
          lastName
          traderType
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const FOREIGN_OFFERS_QUERY = gql`
  ${rateUnitFragment}
  query allForeignOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForeignOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      foreignOffers {
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        expectedShipmentDate
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        portOfLoading {
          id
          name
          city
        }
        portsOfDischarge {
          id
          name
          city
        }
        offerCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const FOREIGN_OFFERS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription allForeignOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForeignOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      foreignOffer {
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        expectedShipmentDate
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        portOfLoading {
          id
          name
          city
        }
        portsOfDischarge {
          id
          name
          city
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const DEMANDS_QUERY = gql`
  ${rateUnitFragment}
  query demands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    demands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demands {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        actualQuantityUnit
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        createdByUserId
        updatedByUserId
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        portsOfDischarge {
          id
          name
          city
        }
        demandCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
        demandGroupId
        isGroupedDemand
        groupedGradeNames
        linkedDemands {
          id
          totalQty
          rate
          grades {
            id
            name
            productSubCategoryManufacturer
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const DEMANDS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription demands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    demands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demand {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        createdByUserId
        updatedByUserId
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
        }
        portsOfDischarge {
          id
          name
          city
        }
        demandGroupId
        isGroupedDemand
        groupedGradeNames
        linkedDemands {
          id
          totalQty
          rate
          grades {
            id
            name
            productSubCategoryManufacturer
          }
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const FORWARD_DEMANDS_QUERY = gql`
  ${rateUnitFragment}
  query allForwardDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForwardDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      forwardDemands {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        demandCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const FORWARD_DEMANDS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription allForwardDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForwardDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      forwardDemand {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const FOREIGN_DEMANDS_QUERY = gql`
  ${rateUnitFragment}
  query allForeignDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForeignDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      foreignDemands {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        portsOfDischarge {
          id
          name
          city
        }
        demandCreatedFor
        nonRegisteredUserName
        nonRegisteredUserPhoneNumber
        nonRegisteredUserCallingCode
        createdByUser {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const FOREIGN_DEMANDS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription allForeignDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allForeignDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      foreignDemand {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        minDeliveryDelay
        maxDeliveryDelay
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          traderType
          callingCode {
            id
            callingCode
          }
        }
        portsOfDischarge {
          id
          name
          city
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const BIDS_QUERY = gql`
  ${rateUnitFragment}
  query bids(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    bids(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      totalPages
      totalCount
      bids {
        id
        bidType
        bidderRole
        updatedAt
        bidStartTime
        bidExpireTime
        childBids {
          bidder {
            firstName
          }
          price
          quantity
          quantityUnit
          rateUnit {
            ...rateUnitInfo
          }
          bidType
        }
        bidder {
          id
          firstName
          entityName
          tradeName
          status
          addresses {
            id
            houseNumber
            city {
              cityName
            }
            state {
              stateName
            }
          }
        }
        offer {
          id
          offerType
        }
        demand {
          id
        }
        grade {
          id
          name
        }
      }
    }
  }
`;
// export const VENDORS_QUERY = gql`
//   query traders(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//     $pagination: Boolean
//   ) {
//     traders(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//       pagination: $pagination
//     ) {
//       traders {
//         id
//         entityName
//         firstName
//         middleName
//         lastName
//         phone
//         status
//         tradeName
//         tradeGstIn
//         createdAt
//         email
//         kycStatus
//         callingCode {
//           id
//           callingCode
//         }
//         kyc {
//           id
//           gstPhoto
//           gstNumber
//           gstStatus
//           gstLocation
//           panPhoto
//           panNumber
//           panStatus
//           aadharNumber
//           aadharFront
//           aadharBack
//           aadharStatus
//           createdAt
//           updatedAt
//         }
//         addresses {
//           id
//           houseNumber
//           street
//           pinCode
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//           country {
//             id
//             country
//             countryCode
//           }
//         }
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

export const VENDORS_QUERY = gql`
  query traders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    traders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      traders {
        id
        firstName
        middleName
        lastName
        entityName
        phone
        status
        totalTradedVolume
        tradeName
        tradeGstIn
        createdAt
        email
        isWhatsappSubscribed
        dailyPriceOptOut
        demandCount
        traderType
        designation
        profile
        kycStatus
        tdsEligible
        callingCodeId
        isNonRegistered
        companyFormationNumber
        isParentTrader
        traderPhone
        sellerOrderCommissionPaid
        sellerCumulativeOrderQty
        traderTags {
          id
          tagName
          colorCode
        }
        userDevices {
          platform
          osType
          appVersion
        }
        livePaymentTerm {
          id
          term
        }
        favGrades {
          id
          name
        }
        parentTrader {
          id
          firstName
          middleName
          lastName
          sellerOrderCommissionPaid
          sellerCumulativeOrderQty
        }
        callingCode {
          id
          callingCode
          country
        }
        userSubscription {
          id
          deactivationDate
          activationDate
          dealQtyUnit
          dealQtyLimit
          isTrial
          userLimit
          status
          subscriptionPlan {
            id
            planName
            createdAt
            status
            currency
          }
        }
        latestUserSubscription {
          id
          deactivationDate
          activationDate
          dealQtyUnit
          dealQtyLimit
          isTrial
          userLimit
          status
          subscriptionPlan {
            id
            planName
            createdAt
            status
            currency
          }
        }
        latestDeactivatedUserSubscription {
          id
          deactivationDate
          activationDate
          dealQtyUnit
          dealQtyLimit
          isTrial
          userLimit
          status
          subscriptionPlan {
            id
            planName
            createdAt
            status
            currency
          }
        }
        dedicatedRM {
          id
          firstName
          middleName
          lastName
          phone
          status
          createdAt
          email
        }
        dedicatedBDE {
          id
          firstName
          middleName
          lastName
          phone
          status
          createdAt
          email
        }
        dedicatedPurchaseManager {
          id
          firstName
          lastName
          email
        }
        rmAssignedAt
        kyc {
          id
          gstPhoto
          gstNumber
          gstStatus
          gstLocation
          gstCity
          gstState
          panPhoto
          panNumber
          panStatus
          aadharNumber
          aadharFront
          aadharBack
          aadharStatus
          createdAt
          updatedAt
          kycStatus
        }
        addresses {
          id
          houseNumber
          street
          pinCode
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
            countryCode
          }
        }
        sellerCommissionSlab {
          id
          commissionTypeName
          minWeight
          maxWeight
          maxRangeRate
          leastRangeRate
          midRangeRate
        }
        buyerCommissionSlab {
          id
          commissionTypeName
          minWeight
          maxWeight
          maxRangeRate
          leastRangeRate
          midRangeRate
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const TRADER_HISTORY_QUERY = gql`
  query traderHistory($traderId: Int!) {
    traderHistory(traderId: $traderId) {
      id
      traderId
      action
      oldValue
      newValue
      updatedByName
      entityType
      createdAt
      metadata
    }
  }
`;

export const getTraderHistoryQuery = (traderId) => gql`
  query {
    traderHistory(traderId: ${traderId}) {
      id
      traderId
      action
      oldValue
      newValue
      updatedByName
      entityType
      createdAt
      metadata
    }
  }
`;

export const INVOICES_QUERY = gql`
  ${rateUnitFragment}
  query invoices(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    invoices(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      invoices {
        id
        rateUnit {
          ...rateUnitInfo
        }
        createdAt
        total
        order {
          id
          seller {
            id
            firstName
            tradeName
            phone
          }
          buyer {
            id
            firstName
            tradeName
            phone
          }
        }
        invoiceStatus
      }
      totalCount
      totalPages
    }
  }
`;

export const INVOICES_QUERY_SUBSCRIPTION = gql`
  ${rateUnitFragment}
  subscription invoices(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    invoices(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      invoice {
        id
        rateUnit {
          ...rateUnitInfo
        }
        createdAt
        total
        order {
          id
          seller {
            id
            firstName
            tradeName
            phone
          }
          buyer {
            id
            firstName
            tradeName
            phone
          }
        }
        invoiceStatus
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const CATEGORY_LIST = gql`
  query categoryList(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    categoryList(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      categoryList {
        id
        name
        status
        photo
        document
        createdAt
      }
      totalCount
      totalPages
    }
  }
`;

export const ORDER_LIST = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  query orders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    orders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      orders {
        id
        sellerCommissionAmount
        buyerCommissionAmount
        isFreeTransitInsuranceIncluded
        insuranceAmount
        bid {
          id
          price
          quantity
          quantityUnit
          createdAt
          bidderRole
          status
          rateUnit {
            ...rateUnitInfo
          }
          bidder {
            entityName
            firstName
            lastName
            phone
            addresses {
              id
              city {
                id
                cityName
              }
              state {
                id
                stateName
              }
            }
            callingCode {
              id
              callingCode
            }
          }
          childBids {
            id
            price
            quantity
            quantityUnit
            createdAt
            bidderRole
            status
            rateUnit {
              ...rateUnitInfo
            }
            bidder {
              entityName
              firstName
              lastName
              phone
              addresses {
                id
                city {
                  id
                  cityName
                }
                state {
                  id
                  stateName
                }
              }
              callingCode {
                id
                callingCode
              }
            }
          }
          parentBid {
            id
          }
          total
        }
        buyer {
          ...sellerInfo
        }
        seller {
          ...sellerInfo
        }
        status
        rate
        quantity
        quantityUnit
        rateUnit {
          ...rateUnitInfo
        }
        grade {
          id
          name
        }
        approvalStatus
        buyerGstBillingAddress
        deliveryAddress {
          id
          houseNumber
          street
          area
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
          }
          pinCode
        }
        billingAddress {
          id
          houseNumber
          street
          area
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
          }
          pinCode
        }
        orderLogistics {
          id
          rateUnit {
            ...rateUnitInfo
          }
          driverName
          driverNumber
          vehicle
          vehicleNumber
          transportName
          transportLR
          loadingCharges
          otherCharges
          freight
          weightSlipDoc
          lrDoc
          vehicleNumberImage
          loadingImage
          orderLogisticStatus
          deliveryDate
          dispatchDate
          cancellationReason
          callingCode {
            id
            callingCode
          }
        }
        paymentStatus
        paymentTransitions {
          id
          status
          paymentMethod
          totalAmount
          dueAmount
          paidAmount
          transactionId
          paymentTransactionDetails
        }
        serviceTaxAmount
        availInsurance
        paymentTerm
        tcsValue
        tcsAmount
        gstValue
        gstAmount
        tdsValue
        tdsAmount
        prepayment
        convenienceAmount
        total
        subtotal
        dueAmount
        deliveryDate
        isLogisticSelf
        isFreightChargeAccepted
        createdAt
        sellerActionTaken
      }
      totalCount
      totalPages
    }
  }
`;

export const ORDER_BY_ID = gql`
  query order($id: ID!) {
    order(id: $id) {
      id
      invoices {
        id
        total
        order {
          id
          seller {
            id
            firstName
            phone
          }
          buyer {
            id
            firstName
            phone
            tradeName
          }
        }
        invoiceStatus
        invoiceNumber
        createdAt
      }
    }
  }
`;
export const STAFF_LIST = gql`
  query usersFilter(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    usersFilter(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      users {
        id
        firstName
        middleName
        lastName
        email
        profile
        phone
        roles {
          id
          name
        }
        callingCode {
          id
          callingCode
        }
        permissions {
          id
          name
          permissionName
        }
        addresses {
          id
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
        }

        assignedTraders {
          id
          firstName
          middleName
          lastName
          email
          phone
          callingCode {
            id
            callingCode
          }
          rmAssignedAt
        }
        bdeAssignedTraders {
          id
          firstName
          middleName
          lastName
          email
          phone
          callingCode {
            id
            callingCode
          }
          bdeAssignedAt
        }
      }
      totalPages
      totalCount
    }
  }
`;
export const RM_LIST = gql`
  query usersFilter(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    usersFilter(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      users {
        id
        firstName
        middleName
        lastName
        email
        profile
        phone
        roles {
          id
          name
        }
        callingCode {
          id
          callingCode
        }
        permissions {
          id
          name
          permissionName
        }
        addresses {
          id
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
        }

        assignedTraders {
          id
          firstName
          middleName
          lastName
          email
          phone
          callingCode {
            id
            callingCode
          }
          rmAssignedAt
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const ORDER_BY_VENDOR_ID = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  query orders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    orders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      orders {
        id
        orderType
        grade {
          id
          name
        }
        buyer {
          ...sellerInfo
          id
        }
        seller {
          ...sellerInfo
          kyc {
            gstLocation
          }
          id
        }
        rateUnit {
          ...rateUnitInfo
        }
        pendingQuantity
        approvalStatus
        paymentStatus
        quantity
        quantityUnit
        rate
        rateUnit {
          id
        }
        status
        createdAt
        total
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        portOfDischarge {
          id
          name
        }
        portOfLoading {
          id
          name
        }
        sellerActionTaken
      }
      totalPages
      totalCount
    }
  }
`;
export const ORDER_BY_VENDOR_ID_SUBSCRIPTION = gql`
  ${sellerFragment}
  ${rateUnitFragment}
  subscription orders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    orders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      orders {
        id
        orderType
        grade {
          id
          name
        }
        buyer {
          ...sellerInfo
          id
        }
        seller {
          ...sellerInfo
          kyc {
            gstLocation
          }
          id
        }
        rateUnit {
          ...rateUnitInfo
        }
        pendingQuantity
        approvalStatus
        paymentStatus
        quantity
        quantityUnit
        rate
        rateUnit {
          id
        }
        status
        createdAt
        total
        city {
          id
          cityName
        }
        state {
          id
          stateName
        }
        portOfDischarge {
          id
          name
        }
        portOfLoading {
          id
          name
        }
        sellerActionTaken
      }
      totalPages
      totalCount
    }
  }
`;

export const ROLES_LIST = gql`
  query roles {
    roles {
      id
      name
    }
  }
`;

export const PERMISSION_LIST = gql`
  query permissions(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    permissions(
      filter: $filter
      pagination: $pagination
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      totalCount
      permissions {
        id
        name
        permissionName
      }
    }
  }
`;

export const BID_OFFERS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription bidOffers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    bidOffers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      offer {
        updatedByUserId
        createdByUserId
        createdAt
        id
        activeBids
        inactiveBids
        offerType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        status
        createdByUserId
        updatedByUserId
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
          callingCode {
            id
            callingCode
          }
        }
        portOfLoading {
          id
          name
          city
        }
        portsOfDischarge {
          id
          name
          city
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const BID_DEMANDS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription bidDemands(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    bidDemands(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      demand {
        id
        createdAt
        activeBids
        inactiveBids
        demandType
        totalQty
        minimumQty
        rate
        quantityUnit
        validityInHours
        validityStartTime
        validityExpireTime
        grades {
          id
          name
          productSubCategoryManufacturer
        }
        rateUnit {
          ...rateUnitInfo
        }
        city {
          id
          cityName
        }
        state {
          id
          stateName
          country {
            id
            country
          }
        }
        status
        createdByUserId
        updatedByUserId
        trader {
          id
          firstName
          lastName
          status
          phone
          entityName
          tradeName
        }
        portOfDischarge {
          id
          name
          city
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const VENDORS_QUERY_SUBSCRIPTION = gql`
  subscription traders(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    traders(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      trader {
        id
        firstName
        middleName
        lastName
        entityName
        phone
        status
        tradeName
        tradeGstIn
        createdAt
        isWhatsappSubscribed
        dailyPriceOptOut
        demandCount
        traderType
        designation
        email
        profile
        kycStatus
        tdsEligible
        callingCodeId
        isNonRegistered
        companyFormationNumber
        isParentTrader
        traderPhone
        sellerOrderCommissionPaid
        sellerCumulativeOrderQty
        userDevices {
          platform
          osType
          appVersion
        }
        livePaymentTerm {
          id
          term
        }
        favGrades {
          id
          name
        }
        parentTrader {
          id
          firstName
          middleName
          lastName
          sellerOrderCommissionPaid
          sellerCumulativeOrderQty
        }
        callingCode {
          id
          callingCode
          country
        }
        userSubscription {
          id
          deactivationDate
          activationDate
          dealQtyUnit
          dealQtyLimit
          isTrial
          userLimit
          status
          subscriptionPlan {
            id
            planName
            createdAt
            status
            currency
          }
        }
        latestUserSubscription {
          id
          deactivationDate
          activationDate
          dealQtyUnit
          dealQtyLimit
          isTrial
          userLimit
          status
          subscriptionPlan {
            id
            planName
            createdAt
            status
            currency
          }
        }
        latestDeactivatedUserSubscription {
          id
          deactivationDate
          activationDate
          dealQtyUnit
          dealQtyLimit
          isTrial
          userLimit
          status
          subscriptionPlan {
            id
            planName
            createdAt
            status
            currency
          }
        }
        dedicatedRM {
          id
          firstName
          middleName
          lastName
          phone
          status
          createdAt
          email
        }
        dedicatedBDE {
          id
          firstName
          middleName
          lastName
          phone
          status
          createdAt
          email
        }
        rmAssignedAt
        kyc {
          id
          gstPhoto
          gstNumber
          gstStatus
          gstLocation
          panPhoto
          panNumber
          panStatus
          aadharNumber
          aadharFront
          aadharBack
          aadharStatus
          kycStatus
          createdAt
          updatedAt
        }
        addresses {
          id
          houseNumber
          street
          pinCode
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
          country {
            id
            country
            countryCode
          }
        }
      }
      totalCount
      totalPages
      action
    }
  }
`;

export const EXPORTS_OFFERS = gql`
  query exportOffers(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportOffers(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const EXPORTS_DEMANDS = gql`
  query exportDemands(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportDemands(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const GET_USER_KYC = gql`
  query userKYC($id: ID!) {
    userKYC(id: $id) {
      id
      aadharFront
      aadharBack
      aadharStatus
      gstPhoto
      gstStatus
      panPhoto
      panStatus
      kycStatus
      companyFormationDocument
      companyFormationDocumentStatus
      foreignIdVerificationDocument
      foreignIdVerificationDocumentStatus
      userVerificationDocument
      userVerificationDocumentStatus
    }
  }
`;

export const UPDATE_USER_KYC = gql`
  mutation updateUserKYC($input: UserKYCInputDTO) {
    updateUserKYC(input: $input)
  }
`;

export const UPDATE_FOREIGN_USER_KYC = gql`
  mutation updateCompanyFormationDocumentForUser(
    $id: ID!
    $companyFormationDocument: String
    $companyFormationDocumentStatus: String
  ) {
    updateCompanyFormationDocumentForUser(
      id: $id
      companyFormationDocument: $companyFormationDocument
      companyFormationDocumentStatus: $companyFormationDocumentStatus
    )
  }
`;

export const LATEST_ALL_BIDS_QUERY = gql`
  ${rateUnitFragment}
  query allBids(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allBids(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      action
      totalPages
      totalCount

      groupedBids {
        latestBid {
          id
          bidType
          offer {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidExpireTime
          demand {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidder {
            id
            entityName
            phone
            callingCode {
              id
              callingCode
            }
            firstName
            lastName
            addresses {
              id
              houseNumber
            }
          }
          grade {
            id
            name
          }
          price
          rateUnit {
            ...rateUnitInfo
          }
          bidderRole
          quantity
          quantityUnit
          status
          updatedAt
        }
        allBids {
          id
          bidType
          offer {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidExpireTime
          demand {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidder {
            id
            entityName
            phone
            callingCode {
              id
              callingCode
            }
            firstName
            lastName
            addresses {
              id
              houseNumber
            }
          }
          grade {
            id
            name
          }
          price
          rateUnit {
            ...rateUnitInfo
          }
          bidderRole
          quantity
          quantityUnit
          status
          updatedAt
        }
      }
    }
  }
`;

export const LATEST_ALL_BIDS_SUBSCRIPTION_QUERY = gql`
  ${rateUnitFragment}
  subscription allBids(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allBids(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      action
      totalPages
      totalCount
      groupedBid {
        latestBid {
          id
          offer {
            id
          }
        }
        allBids {
          id
          offer {
            id
          }
        }
      }
      groupedBids {
        latestBid {
          id
          bidType
          offer {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidExpireTime
          demand {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidder {
            id
            entityName
            phone
            callingCode {
              id
              callingCode
            }
            firstName
            lastName
            addresses {
              id
              houseNumber
            }
          }
          grade {
            id
            name
          }
          price
          rateUnit {
            ...rateUnitInfo
          }
          bidderRole
          quantity
          quantityUnit
          status
          updatedAt
        }
        allBids {
          id
          bidType
          offer {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidExpireTime
          demand {
            id
            totalQty
            minimumQty
            quantityUnit
            actualQuantityUnit
            rate
            grades {
              id
              name
              productSubCategoryManufacturer
            }
            city {
              id
              cityName
            }
            state {
              id
              stateName
            }
            portsOfDischarge {
              id
              name
            }
            trader {
              id
              entityName
              phone
              callingCode {
                id
                callingCode
              }
            }
          }
          bidder {
            id
            entityName
            phone
            callingCode {
              id
              callingCode
            }
            firstName
            lastName
            addresses {
              id
              houseNumber
            }
          }
          grade {
            id
            name
          }
          price
          rateUnit {
            ...rateUnitInfo
          }
          bidderRole
          quantity
          quantityUnit
          status
          updatedAt
        }
      }
    }
  }
`;

export const GET_ADMIN_UNSEEN_NOTIFICATION_COUNT = gql`
  query getAdminUnseenNotificationCount {
    getAdminUnseenNotificationCount {
      bidCount
      orderCount
      vendorCount
      marketListingCount
      offerCount
      demandCount
      notificationCount
      productCount
    }
  }
`;

export const GET_ADMIN_UNSEEN_NOTIFICATION_COUNT_SUBSCRIPTION = gql`
  subscription getAdminUnseenNotificationCount {
    getAdminUnseenNotificationCount {
      bidCount
      orderCount
      vendorCount
      marketListingCount
      offerCount
      demandCount
      notificationCount
    }
  }
`;

export const READ_ADMIN_UNSEEN_MODULE = gql`
  mutation readAdminUnseenModule($module: [String]) {
    readAdminUnseenModule(module: $module)
  }
`;

// /* eslint-disable react/react-in-jsx-scope */
// import { gql } from '@apollo/client';
// import { rateUnitFragment, sellerFragment } from 'helper/fragment';

// // Updated to use userLogin based on API response
// export const LOGIN = gql`
//   mutation userLogin($email: String!, $password: String!) {
//     userLogin(email: $email, password: $password) {
//       token
//       user {
//         id
//         firstName
//         roles {
//           id
//           name
//         }
//       }
//     }
//   }
// `;
// export const OFFERS_QUERY = gql`
//   ${rateUnitFragment}
//   query offers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     offers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       offers {
//         updatedByUserId
//         createdByUserId
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portOfLoading {
//           id
//           name
//           city
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// // ... (The rest of your original file remains unchanged. I've omitted it here for brevity, but keep all other queries/subscriptions as-is in your file.)

// export const OFFERS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription offers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     offers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       offer {
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         createdByUserId
//         updatedByUserId
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portOfLoading {
//           id
//           name
//           city
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const FORWARD_OFFERS_QUERY = gql`
//   ${rateUnitFragment}
//   query allForwardOffers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForwardOffers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       forwardOffers {
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const FORWARD_OFFERS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription allForwardOffers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForwardOffers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       forwardOffer {
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const FOREIGN_OFFERS_QUERY = gql`
//   ${rateUnitFragment}
//   query allForeignOffers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForeignOffers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       foreignOffers {
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         expectedShipmentDate
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portOfLoading {
//           id
//           name
//           city
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const FOREIGN_OFFERS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription allForeignOffers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForeignOffers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       foreignOffer {
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         expectedShipmentDate
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portOfLoading {
//           id
//           name
//           city
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const DEMANDS_QUERY = gql`
//   ${rateUnitFragment}
//   query demands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     demands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       demands {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         createdByUserId
//         updatedByUserId
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const DEMANDS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription demands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     demands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       demand {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         createdByUserId
//         updatedByUserId
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const FORWARD_DEMANDS_QUERY = gql`
//   ${rateUnitFragment}
//   query allForwardDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForwardDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       forwardDemands {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const FORWARD_DEMANDS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription allForwardDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForwardDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       forwardDemand {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const FOREIGN_DEMANDS_QUERY = gql`
//   ${rateUnitFragment}
//   query allForeignDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForeignDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       foreignDemands {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const FOREIGN_DEMANDS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription allForeignDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allForeignDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       foreignDemand {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         minDeliveryDelay
//         maxDeliveryDelay
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const BIDS_QUERY = gql`
//   ${rateUnitFragment}
//   query bids(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     bids(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       totalPages
//       totalCount
//       bids {
//         id
//         bidType
//         bidderRole
//         updatedAt
//         bidStartTime
//         bidExpireTime
//         childBids {
//           bidder {
//             firstName
//           }
//           price
//           quantity
//           quantityUnit
//           rateUnit {
//             ...rateUnitInfo
//           }
//           bidType
//         }
//         bidder {
//           id
//           firstName
//           entityName
//           tradeName
//           status
//           addresses {
//             id
//             houseNumber
//             city {
//               cityName
//             }
//             state {
//               stateName
//             }
//           }
//         }
//         offer {
//           id
//           offerType
//         }
//         demand {
//           id
//         }
//         grade {
//           id
//           name
//         }
//       }
//     }
//   }
// `;
// // export const VENDORS_QUERY = gql`
// //   query traders(
// //     $filter: [FilterMap]
// //     $pageNo: Int
// //     $pageSize: Int
// //     $sortCol: String
// //     $sortDirection: String
// //     $pagination: Boolean
// //   ) {
// //     traders(
// //       filter: $filter
// //       pageNo: $pageNo
// //       pageSize: $pageSize
// //       sortCol: $sortCol
// //       sortDirection: $sortDirection
// //       pagination: $pagination
// //     ) {
// //       traders {
// //         id
// //         entityName
// //         firstName
// //         middleName
// //         lastName
// //         phone
// //         status
// //         tradeName
// //         tradeGstIn
// //         createdAt
// //         email
// //         kycStatus
// //         callingCode {
// //           id
// //           callingCode
// //         }
// //         kyc {
// //           id
// //           gstPhoto
// //           gstNumber
// //           gstStatus
// //           gstLocation
// //           panPhoto
// //           panNumber
// //           panStatus
// //           aadharNumber
// //           aadharFront
// //           aadharBack
// //           aadharStatus
// //           createdAt
// //           updatedAt
// //         }
// //         addresses {
// //           id
// //           houseNumber
// //           street
// //           pinCode
// //           city {
// //             id
// //             cityName
// //           }
// //           state {
// //             id
// //             stateName
// //           }
// //           country {
// //             id
// //             country
// //             countryCode
// //           }
// //         }
// //       }
// //       totalCount
// //       totalPages
// //     }
// //   }
// // `;

// export const VENDORS_QUERY = gql`
//   query traders(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     traders(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       traders {
//         id
//         firstName
//         middleName
//         lastName
//         entityName
//         phone
//         status
//         tradeName
//         tradeGstIn
//         createdAt
//         email
//         isWhatsappSubscribed
//         profile
//         kycStatus
//         tdsEligible
//         callingCodeId
//         companyFormationNumber
//         isParentTrader
//         traderPhone
//         sellerOrderCommissionPaid
//         sellerCumulativeOrderQty
//         userDevices {
//           platform
//           osType
//           appVersion
//         }
//         livePaymentTerm {
//           id
//           term
//         }
//         favGrades {
//           id
//           name
//         }
//         parentTrader {
//           id
//           firstName
//           middleName
//           lastName
//           sellerOrderCommissionPaid
//           sellerCumulativeOrderQty
//         }
//         callingCode {
//           id
//           callingCode
//           country
//         }
//         userSubscription {
//           id
//           deactivationDate
//           activationDate
//           dealQtyUnit
//           dealQtyLimit
//           isTrial
//           userLimit
//           status
//           subscriptionPlan {
//             id
//             planName
//             createdAt
//             status
//             currency
//           }
//         }
//         latestUserSubscription {
//           id
//           deactivationDate
//           activationDate
//           dealQtyUnit
//           dealQtyLimit
//           isTrial
//           userLimit
//           status
//           subscriptionPlan {
//             id
//             planName
//             createdAt
//             status
//             currency
//           }
//         }
//         latestDeactivatedUserSubscription {
//           id
//           deactivationDate
//           activationDate
//           dealQtyUnit
//           dealQtyLimit
//           isTrial
//           userLimit
//           status
//           subscriptionPlan {
//             id
//             planName
//             createdAt
//             status
//             currency
//           }
//         }
//         dedicatedRM {
//           id
//           firstName
//           middleName
//           lastName
//           phone
//           status
//           createdAt
//           email
//         }
//         dedicatedBDE {
//           id
//           firstName
//           middleName
//           lastName
//           phone
//           status
//           createdAt
//           email
//         }
//         rmAssignedAt
//         kyc {
//           id
//           gstPhoto
//           gstNumber
//           gstStatus
//           gstLocation
//           panPhoto
//           panNumber
//           panStatus
//           aadharNumber
//           aadharFront
//           aadharBack
//           aadharStatus
//           createdAt
//           updatedAt
//           kycStatus
//         }
//         addresses {
//           id
//           houseNumber
//           street
//           pinCode
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//           country {
//             id
//             country
//             countryCode
//           }
//         }
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

// export const INVOICES_QUERY = gql`
//   ${rateUnitFragment}
//   query invoices(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     invoices(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       invoices {
//         id
//         rateUnit {
//           ...rateUnitInfo
//         }
//         createdAt
//         total
//         order {
//           id
//           seller {
//             id
//             firstName
//             tradeName
//             phone
//           }
//           buyer {
//             id
//             firstName
//             tradeName
//             phone
//           }
//         }
//         invoiceStatus
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

// export const INVOICES_QUERY_SUBSCRIPTION = gql`
//   ${rateUnitFragment}
//   subscription invoices(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     invoices(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       invoice {
//         id
//         rateUnit {
//           ...rateUnitInfo
//         }
//         createdAt
//         total
//         order {
//           id
//           seller {
//             id
//             firstName
//             tradeName
//             phone
//           }
//           buyer {
//             id
//             firstName
//             tradeName
//             phone
//           }
//         }
//         invoiceStatus
//       }
//       totalCount
//       totalPages
//       action
//     }
//   }
// `;

// export const CATEGORY_LIST = gql`
//   query categoryList(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     categoryList(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       categoryList {
//         id
//         name
//         status
//         photo
//         document
//         createdAt
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

// export const ORDER_LIST = gql`
//   ${sellerFragment}
//   ${rateUnitFragment}
//   query orders(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     orders(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       orders {
//         id
//         sellerCommissionAmount
//         isFreeTransitInsuranceIncluded
//         insuranceAmount
//         bid {
//           id
//           price
//           quantity
//           quantityUnit
//           createdAt
//           bidderRole
//           status
//           rateUnit {
//             ...rateUnitInfo
//           }
//           bidder {
//             entityName
//             firstName
//             lastName
//             phone
//             addresses {
//               id
//               city {
//                 id
//                 cityName
//               }
//               state {
//                 id
//                 stateName
//               }
//             }
//             callingCode {
//               id
//               callingCode
//             }
//           }
//           childBids {
//             id
//             price
//             quantity
//             quantityUnit
//             createdAt
//             bidderRole
//             status
//             rateUnit {
//               ...rateUnitInfo
//             }
//             bidder {
//               entityName
//               firstName
//               lastName
//               phone
//               addresses {
//                 id
//                 city {
//                   id
//                   cityName
//                 }
//                 state {
//                   id
//                   stateName
//                 }
//               }
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           parentBid {
//             id
//           }
//           total
//         }
//         buyer {
//           ...sellerInfo
//         }
//         seller {
//           ...sellerInfo
//         }
//         status
//         rate
//         quantity
//         quantityUnit
//         rateUnit {
//           ...rateUnitInfo
//         }
//         grade {
//           id
//           name
//         }
//         buyerGstBillingAddress
//         deliveryAddress {
//           id
//           houseNumber
//           street
//           area
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//           country {
//             id
//             country
//           }
//           pinCode
//         }
//         billingAddress {
//           id
//           houseNumber
//           street
//           area
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//           country {
//             id
//             country
//           }
//           pinCode
//         }
//         orderLogistics {
//           id
//           rateUnit {
//             ...rateUnitInfo
//           }
//           driverName
//           driverNumber
//           vehicle
//           vehicleNumber
//           transportName
//           transportLR
//           loadingCharges
//           otherCharges
//           freight
//           weightSlipDoc
//           lrDoc
//           vehicleNumberImage
//           loadingImage
//           orderLogisticStatus
//           deliveryDate
//           dispatchDate
//           cancellationReason
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         paymentStatus
//         paymentTransitions {
//           id
//           status
//           paymentMethod
//           totalAmount
//           dueAmount
//           paidAmount
//           transactionId
//           paymentTransactionDetails
//         }
//         serviceTaxAmount
//         availInsurance
//         paymentTerm
//         tcsValue
//         tcsAmount
//         gstValue
//         gstAmount
//         tdsValue
//         tdsAmount
//         prepayment
//         convenienceAmount
//         total
//         subtotal
//         dueAmount
//         deliveryDate
//         createdAt
//       }
//       totalCount
//       totalPages
//     }
//   }
// `;

// export const ORDER_BY_ID = gql`
//   query order($id: ID!) {
//     order(id: $id) {
//       id
//       invoices {
//         id
//         total
//         order {
//           id
//           seller {
//             id
//             firstName
//             phone
//           }
//           buyer {
//             id
//             firstName
//             phone
//             tradeName
//           }
//         }
//         invoiceStatus
//         invoiceNumber
//         createdAt
//       }
//     }
//   }
// `;
// export const STAFF_LIST = gql`
//   query usersFilter(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     usersFilter(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       users {
//         id
//         firstName
//         middleName
//         lastName
//         email
//         profile
//         phone
//         roles {
//           id
//           name
//         }
//         callingCode {
//           id
//           callingCode
//         }
//         permissions {
//           id
//           name
//           permissionName
//         }
//         addresses {
//           id
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//         }

//         assignedTraders {
//           id
//           firstName
//           middleName
//           lastName
//           email
//           phone
//           callingCode {
//             id
//             callingCode
//           }
//           rmAssignedAt
//         }
//         bdeAssignedTraders {
//           id
//           firstName
//           middleName
//           lastName
//           email
//           phone
//           callingCode {
//             id
//             callingCode
//           }
//           bdeAssignedAt
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;
// export const RM_LIST = gql`
//   query usersFilter(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//     $pagination: Boolean
//   ) {
//     usersFilter(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//       pagination: $pagination
//     ) {
//       users {
//         id
//         firstName
//         middleName
//         lastName
//         email
//         profile
//         phone
//         roles {
//           id
//           name
//         }
//         callingCode {
//           id
//           callingCode
//         }
//         permissions {
//           id
//           name
//           permissionName
//         }
//         addresses {
//           id
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//         }

//         assignedTraders {
//           id
//           firstName
//           middleName
//           lastName
//           email
//           phone
//           callingCode {
//             id
//             callingCode
//           }
//           rmAssignedAt
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const ORDER_BY_VENDOR_ID = gql`
//   ${sellerFragment}
//   ${rateUnitFragment}
//   query orders(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     orders(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       orders {
//         id
//         orderType
//         grade {
//           id
//           name
//         }
//         buyer {
//           ...sellerInfo
//           id
//         }
//         seller {
//           ...sellerInfo
//           kyc {
//             gstLocation
//           }
//           id
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         pendingQuantity
//         approvalStatus
//         paymentStatus
//         quantity
//         quantityUnit
//         rate
//         rateUnit {
//           id
//         }
//         status
//         createdAt
//         total
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//         }
//         portOfDischarge {
//           id
//           name
//         }
//         portOfLoading {
//           id
//           name
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;
// export const ORDER_BY_VENDOR_ID_SUBSCRIPTION = gql`
//   ${sellerFragment}
//   ${rateUnitFragment}
//   subscription orders(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     orders(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       orders {
//         id
//         orderType
//         grade {
//           id
//           name
//         }
//         buyer {
//           ...sellerInfo
//           id
//         }
//         seller {
//           ...sellerInfo
//           kyc {
//             gstLocation
//           }
//           id
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         pendingQuantity
//         approvalStatus
//         paymentStatus
//         quantity
//         quantityUnit
//         rate
//         rateUnit {
//           id
//         }
//         status
//         createdAt
//         total
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//         }
//         portOfDischarge {
//           id
//           name
//         }
//         portOfLoading {
//           id
//           name
//         }
//       }
//       totalPages
//       totalCount
//     }
//   }
// `;

// export const ROLES_LIST = gql`
//   query roles {
//     roles {
//       id
//       name
//     }
//   }
// `;

// export const PERMISSION_LIST = gql`
//   query permissions(
//     $filter: [FilterMap]
//     $sortCol: String
//     $sortDirection: String
//     $pagination: Boolean
//   ) {
//     permissions(
//       filter: $filter
//       pagination: $pagination
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       totalCount
//       permissions {
//         id
//         name
//         permissionName
//       }
//     }
//   }
// `;

// export const BID_OFFERS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription bidOffers(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     bidOffers(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       offer {
//         updatedByUserId
//         createdByUserId
//         createdAt
//         id
//         activeBids
//         inactiveBids
//         offerType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         status
//         createdByUserId
//         updatedByUserId
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//           callingCode {
//             id
//             callingCode
//           }
//         }
//         portOfLoading {
//           id
//           name
//           city
//         }
//         portsOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const BID_DEMANDS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription bidDemands(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     bidDemands(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       demand {
//         id
//         createdAt
//         activeBids
//         inactiveBids
//         demandType
//         totalQty
//         minimumQty
//         rate
//         quantityUnit
//         validityInHours
//         validityStartTime
//         validityExpireTime
//         grades {
//           id
//           name
//         }
//         rateUnit {
//           ...rateUnitInfo
//         }
//         city {
//           id
//           cityName
//         }
//         state {
//           id
//           stateName
//           country {
//             id
//             country
//           }
//         }
//         status
//         createdByUserId
//         updatedByUserId
//         trader {
//           id
//           firstName
//           lastName
//           status
//           phone
//           entityName
//           tradeName
//         }
//         portOfDischarge {
//           id
//           name
//           city
//         }
//       }
//       totalPages
//       totalCount
//       action
//     }
//   }
// `;

// export const VENDORS_QUERY_SUBSCRIPTION = gql`
//   subscription traders(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     traders(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       trader {
//         id
//         firstName
//         middleName
//         lastName
//         entityName
//         phone
//         status
//         tradeName
//         tradeGstIn
//         createdAt
//         isWhatsappSubscribed
//         email
//         profile
//         kycStatus
//         tdsEligible
//         callingCodeId
//         companyFormationNumber
//         isParentTrader
//         traderPhone
//         sellerOrderCommissionPaid
//         sellerCumulativeOrderQty
//         userDevices {
//           platform
//           osType
//           appVersion
//         }
//         livePaymentTerm {
//           id
//           term
//         }
//         favGrades {
//           id
//           name
//         }
//         parentTrader {
//           id
//           firstName
//           middleName
//           lastName
//           sellerOrderCommissionPaid
//           sellerCumulativeOrderQty
//         }
//         callingCode {
//           id
//           callingCode
//           country
//         }
//         userSubscription {
//           id
//           deactivationDate
//           activationDate
//           dealQtyUnit
//           dealQtyLimit
//           isTrial
//           userLimit
//           status
//           subscriptionPlan {
//             id
//             planName
//             createdAt
//             status
//             currency
//           }
//         }
//         latestUserSubscription {
//           id
//           deactivationDate
//           activationDate
//           dealQtyUnit
//           dealQtyLimit
//           isTrial
//           userLimit
//           status
//           subscriptionPlan {
//             id
//             planName
//             createdAt
//             status
//             currency
//           }
//         }
//         latestDeactivatedUserSubscription {
//           id
//           deactivationDate
//           activationDate
//           dealQtyUnit
//           dealQtyLimit
//           isTrial
//           userLimit
//           status
//           subscriptionPlan {
//             id
//             planName
//             createdAt
//             status
//             currency
//           }
//         }
//         dedicatedRM {
//           id
//           firstName
//           middleName
//           lastName
//           phone
//           status
//           createdAt
//           email
//         }
//         dedicatedBDE {
//           id
//           firstName
//           middleName
//           lastName
//           phone
//           status
//           createdAt
//           email
//         }
//         rmAssignedAt
//         kyc {
//           id
//           gstPhoto
//           gstNumber
//           gstStatus
//           gstLocation
//           panPhoto
//           panNumber
//           panStatus
//           aadharNumber
//           aadharFront
//           aadharBack
//           aadharStatus
//           kycStatus
//           createdAt
//           updatedAt
//         }
//         addresses {
//           id
//           houseNumber
//           street
//           pinCode
//           city {
//             id
//             cityName
//           }
//           state {
//             id
//             stateName
//           }
//           country {
//             id
//             country
//             countryCode
//           }
//         }
//       }
//       totalCount
//       totalPages
//       action
//     }
//   }
// `;

// export const EXPORTS_OFFERS = gql`
//   query exportOffers(
//     $filter: [FilterMap]
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     exportOffers(
//       filter: $filter
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     )
//   }
// `;

// export const EXPORTS_DEMANDS = gql`
//   query exportDemands(
//     $filter: [FilterMap]
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     exportDemands(
//       filter: $filter
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     )
//   }
// `;

// export const GET_USER_KYC = gql`
//   query userKYC($id: ID!) {
//     userKYC(id: $id) {
//       id
//       aadharFront
//       aadharBack
//       aadharStatus
//       gstPhoto
//       gstStatus
//       panPhoto
//       panStatus
//       kycStatus
//       companyFormationDocument
//       companyFormationDocumentStatus
//       foreignIdVerificationDocument
//       foreignIdVerificationDocumentStatus
//       userVerificationDocument
//       userVerificationDocumentStatus
//     }
//   }
// `;

// export const UPDATE_USER_KYC = gql`
//   mutation updateUserKYC($input: UserKYCInputDTO) {
//     updateUserKYC(input: $input)
//   }
// `;

// export const UPDATE_FOREIGN_USER_KYC = gql`
//   mutation updateCompanyFormationDocumentForUser(
//     $id: ID!
//     $companyFormationDocument: String
//     $companyFormationDocumentStatus: String
//   ) {
//     updateCompanyFormationDocumentForUser(
//       id: $id
//       companyFormationDocument: $companyFormationDocument
//       companyFormationDocumentStatus: $companyFormationDocumentStatus
//     )
//   }
// `;

// export const LATEST_ALL_BIDS_QUERY = gql`
//   ${rateUnitFragment}
//   query allBids(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allBids(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       action
//       totalPages
//       totalCount

//       groupedBids {
//         latestBid {
//           id
//           bidType
//           offer {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidExpireTime
//           demand {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidder {
//             id
//             entityName
//             phone
//             callingCode {
//               id
//               callingCode
//             }
//             firstName
//             lastName
//             addresses {
//               id
//               houseNumber
//             }
//           }
//           grade {
//             id
//             name
//           }
//           price
//           rateUnit {
//             ...rateUnitInfo
//           }
//           bidderRole
//           quantity
//           quantityUnit
//           status
//           updatedAt
//         }
//         allBids {
//           id
//           bidType
//           offer {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidExpireTime
//           demand {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidder {
//             id
//             entityName
//             phone
//             callingCode {
//               id
//               callingCode
//             }
//             firstName
//             lastName
//             addresses {
//               id
//               houseNumber
//             }
//           }
//           grade {
//             id
//             name
//           }
//           price
//           rateUnit {
//             ...rateUnitInfo
//           }
//           bidderRole
//           quantity
//           quantityUnit
//           status
//           updatedAt
//         }
//       }
//     }
//   }
// `;

// export const LATEST_ALL_BIDS_SUBSCRIPTION_QUERY = gql`
//   ${rateUnitFragment}
//   subscription allBids(
//     $filter: [FilterMap]
//     $pageNo: Int
//     $pageSize: Int
//     $sortCol: String
//     $sortDirection: String
//   ) {
//     allBids(
//       filter: $filter
//       pageNo: $pageNo
//       pageSize: $pageSize
//       sortCol: $sortCol
//       sortDirection: $sortDirection
//     ) {
//       action
//       totalPages
//       totalCount
//       groupedBid {
//         latestBid {
//           id
//           offer {
//             id
//           }
//         }
//         allBids {
//           id
//           offer {
//             id
//           }
//         }
//       }
//       groupedBids {
//         latestBid {
//           id
//           bidType
//           offer {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidExpireTime
//           demand {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidder {
//             id
//             entityName
//             phone
//             callingCode {
//               id
//               callingCode
//             }
//             firstName
//             lastName
//             addresses {
//               id
//               houseNumber
//             }
//           }
//           grade {
//             id
//             name
//           }
//           price
//           rateUnit {
//             ...rateUnitInfo
//           }
//           bidderRole
//           quantity
//           quantityUnit
//           status
//           updatedAt
//         }
//         allBids {
//           id
//           bidType
//           offer {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidExpireTime
//           demand {
//             id
//             totalQty
//             minimumQty
//             quantityUnit
//             rate
//             grades {
//               id
//               name
//             }
//             city {
//               id
//               cityName
//             }
//             state {
//               id
//               stateName
//             }
//             portsOfDischarge {
//               id
//               name
//             }
//             trader {
//               id
//               entityName
//               phone
//               callingCode {
//                 id
//                 callingCode
//               }
//             }
//           }
//           bidder {
//             id
//             entityName
//             phone
//             callingCode {
//               id
//               callingCode
//             }
//             firstName
//             lastName
//             addresses {
//               id
//               houseNumber
//             }
//           }
//           grade {
//             id
//             name
//           }
//           price
//           rateUnit {
//             ...rateUnitInfo
//           }
//           bidderRole
//           quantity
//           quantityUnit
//           status
//           updatedAt
//         }
//       }
//     }
//   }
// `;

// export const GET_ADMIN_UNSEEN_NOTIFICATION_COUNT = gql`
//   query getAdminUnseenNotificationCount {
//     getAdminUnseenNotificationCount {
//       bidCount
//       orderCount
//       vendorCount
//       marketListingCount
//       offerCount
//       demandCount
//       notificationCount
//     }
//   }
// `;

// export const GET_ADMIN_UNSEEN_NOTIFICATION_COUNT_SUBSCRIPTION = gql`
//   subscription getAdminUnseenNotificationCount {
//     getAdminUnseenNotificationCount {
//       bidCount
//       orderCount
//       vendorCount
//       marketListingCount
//       offerCount
//       demandCount
//       notificationCount
//     }
//   }
// `;

// export const READ_ADMIN_UNSEEN_MODULE = gql`
//   mutation readAdminUnseenModule($module: [String]) {
//     readAdminUnseenModule(module: $module)
//   }
// `;
